import type { Feature } from '@luna/gatekeeper';

export const changePinDelivery: Feature = {
    enabled: false,
    _description: 'Displays the refactored pin change delivery focus page',
};
